import DefaultLayout from '../layouts/Layout'
import Page404 from './Page404'
import Page500 from './Page500'
export default [

    {
        path: '',
        component: DefaultLayout,
        children: [
            { path: "/page500", component: Page500, name: 'page.500', meta: { guestRoute: true }},
            { path: "/page404", component: Page404, name: 'page.404', meta: { guestRoute: true }},
            { path: "*", component: Page404, meta: { guestRoute: true }}
        ]
    },
]
